import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOriganization = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 17 17",
	stroke: "currentColor",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.14511 2.08274C7.0406 2.07128 6.13593 2.95738 6.12448 4.06189C6.11302 5.1664 6.99911 6.07107 8.10362 6.08253C9.20813 6.09398 10.1128 5.20789 10.1243 4.10338C10.1357 2.99887 9.24962 2.0942 8.14511 2.08274Z",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.0611 10.1238C10.9566 10.1123 10.0519 10.9984 10.0405 12.1029C10.029 13.2074 10.9151 14.1121 12.0196 14.1235C13.1241 14.135 14.0288 13.2489 14.0403 12.1444C14.0517 11.0399 13.1656 10.1352 12.0611 10.1238Z",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.06211 10.041C2.9576 10.0295 2.05293 10.9156 2.04147 12.0201C2.03001 13.1246 2.91611 14.0293 4.02062 14.0408C5.12513 14.0522 6.0298 13.1661 6.04125 12.0616C6.05271 10.9571 5.16662 10.0525 4.06211 10.041Z",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.06195 10.0408L4.07578 8.70753C4.07993 8.30756 4.34935 8.04367 4.74933 8.04782L11.4156 8.11697C11.8156 8.12112 12.0795 8.39054 12.0754 8.79052L12.0615 10.1238",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.08203 8.08252L8.10278 6.08263",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgOriganization;
